var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feedback app-container" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "el-card",
          { staticClass: "form" },
          [
            _c(
              "el-alert",
              {
                staticClass: "notice",
                attrs: { type: "info", effect: "light", closable: false }
              },
              [
                _vm.lang === "zh"
                  ? [
                      _c("strong", [
                        _vm._v("您的反馈意见对我们优化产品非常重要！")
                      ]),
                      _c("br"),
                      _vm._v(
                        " 您可以在这里畅所欲言，提供您的建议和我们需要完善提升的地方。"
                      ),
                      _c("br"),
                      _vm._v(
                        " 您可以选择留下您的联系方式，方便我们进一步了解您的使用情况。 "
                      )
                    ]
                  : [
                      _c("strong", [
                        _vm._v(
                          "Your feedback is very important for us to improve the product!"
                        )
                      ]),
                      _c("br"),
                      _vm._v(
                        " You can comment anything here and provide any suggestions and what we should enhance about."
                      ),
                      _c("br"),
                      _vm._v(
                        " You can leave your contact info here for us to get better understanding about how you are using our product. "
                      )
                    ]
              ],
              2
            ),
            _c(
              "el-form",
              {
                ref: "form",
                attrs: { model: _vm.form, "label-width": "80px" },
                model: {
                  value: _vm.form,
                  callback: function($$v) {
                    _vm.form = $$v
                  },
                  expression: "form"
                }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Email"), prop: "email" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: _vm.$t("Please enter your email") },
                      model: {
                        value: _vm.form.email,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "email", $$v)
                        },
                        expression: "form.email"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: _vm.$t("Wechat"), prop: "wechat" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: _vm.$t("Please enter your Wechat account")
                      },
                      model: {
                        value: _vm.form.wechat,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "wechat", $$v)
                        },
                        expression: "form.wechat"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("Content"),
                      prop: "content",
                      required: ""
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: "5",
                        placeholder: _vm.$t(
                          "Please enter your feedback content"
                        )
                      },
                      model: {
                        value: _vm.form.content,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "content", $$v)
                        },
                        expression: "form.content"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    staticClass: "rating",
                    attrs: {
                      label: _vm.$t("Rating"),
                      prop: "rating",
                      required: ""
                    }
                  },
                  [
                    _c("el-rate", {
                      model: {
                        value: _vm.form.rating,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "rating", $$v)
                        },
                        expression: "form.rating"
                      }
                    })
                  ],
                  1
                ),
                _c("el-form-item", [
                  _c(
                    "div",
                    { staticClass: "actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: _vm.isLoading ? "el-icon-loading" : "",
                            disabled: _vm.isLoading
                          },
                          on: { click: _vm.submit }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("Submit")) + " ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }